import React from "react";
import {useTranslation} from "react-i18next";
const Museum = () => {
  const [ t ] = useTranslation(['home']);
  return (
    <div className="pt-10 mt-5 pb-10" id="MuseumSection">
      <div className="container  ">
        <div className="row">
          <div className="col-12 col-lg-6 ">
            <div className="pt-10">
              <label className="section-subtitle">{t('GalleryRack')}</label>
              <h1 className="section-title rleft">{t('TurnArround')}</h1>
              <p className="section-description">
                {t('AsPartOfOurInnovative')} {" "}
                <span> {t('VirtualRealityGallery')} </span>
                {t('WhereYouCanSeeAll')} <span>NFTs de Racks </span>
                 {t('AndYourAudience')}
              </p>
            </div>
          </div>
          <div className="col-lg-6 col-12">
            <div className=" w-100">
              <div className="museum__image-wrapper w-100">
                <a
                  href="https://oncyber.io/racksmafia"
                  target="_blank"
                  className="btn-native-child"
                >
                  {t('DiscoverIt')}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Museum;
